<template>
  <v-row
    align="center"
    justify="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
      lg="4"
      xl="3"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="my-4">
          <v-img
            contain
            src="/img/header_logo.png"
            height="40px"
            alt="NetWorkT Team & Telekom Logo"
          />
        </v-col>
      </v-row>
      <v-card outlined max-width="500px">
        <v-tabs
          v-model="tab"
          fixed-tabs
        >
          <v-tab>
            Login
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <Login />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Layout from '@/Layouts/Basic'
import Login from '@/Components/Auth/Login'

export default {
   components: {
      Login,
   },
   layout: (h, page) => h(Layout, [page]),
   metaInfo: { title: 'Login' },

   data () {
      return {
         tab: null,
      }
   },
   methods: {
      //
   },
}
</script>
